import React, {Component} from "react";
import FJUtil from "../../../util/FJUtil";
import styles from "./FJTransparency.module.less";
import FJSliderInput from "../../../common/component/slider/FJSliderInput";
import FJLocalStore from "../../../store/FJLocalStore";
import FJToolbarIconButton from "./FJToolbarIconButton";
import InlineSVG from "react-inlinesvg";
import FJDropDown from "fj-components/FJDropDown"
import opacityIcon from '../../../icon/opacity.svg'

class FJTransparency extends Component{


	constructor(props) {
		super(props);
		this.slider = React.createRef();
		this.dropDown = React.createRef();
	}

	componentDidMount() {
		this._updateVolume(this.props.opacityValue);
	};

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.opacityValue !== this.props.opacityValue) {
			this._updateVolume(this.props.opacityValue);
		}
	}

	componentWillUnmount() {
    this._toggleTooltip(this.dropDown.current.getTriggerEle(), false);
  }

  _switchEnableMute(enable) {

		let func = (value) => {
			this._updateVolume(value);
			this._volumeDataChange({type: "slideStart", value});
			this._volumeDataChange({type: "changed", value});
			this._volumeDataChange({type: "slideStop", value});
		};

		if (enable) {
			func(0);
		} else {
			func(100);
		}
	};

	_updateVolume = (value) => {
		this.slider.current.updateSlider(Math.floor(value), true);
	};

	_opacityChange = (data) => {
		this.props.opacityChange(data.type, data.value);
	};

	isActive() {
		return this.dropDown.current.isShow();
	}

	onShow = () => {
		let {toggleEventHide} = this.props;
		if (toggleEventHide) {
			toggleEventHide(false);
		}
	};
	onHide = (e) => {
		let {toggleEventHide} = this.props;
		if (toggleEventHide) {
			toggleEventHide(true, e);
		}
	};

	_toggleTooltip = (ele, bool) => {
		FJUtil.toggleTooltip(ele, bool);
	};

	render() {
		let {
			disabled,
		} = this.props;
		return (
			<FJDropDown overlay={
				<div className={styles.popup_panel}>
					<FJSliderInput ref={this.slider}
                         callback={this._opacityChange}
												 name={FJLocalStore._('opacity')}
                         min={0}
                         max={100}
                         showPercentage/>
				</div>
			}
                  ref={this.dropDown}
                  useAnchorBody
                  isTopLayer
									overlayClassName='c-overlay-bg'
									onShow={this.onShow}
									onHide={this.onHide}
									canTriggerActive
                  disabled={disabled}
									hasArrow={true}
									toggleTooltip={this._toggleTooltip}
			>
				<FJToolbarIconButton disabled={disabled}
														 className='u-tooltip-bottom c-toolbar-icon-btn float-left'
														 tooltip={FJLocalStore._('opacity') }
														 icon={<InlineSVG src={opacityIcon} element='div'/>} />
			</FJDropDown>
		);
	}
}

export default FJTransparency;